export enum EVENT_NAMES {
  ASSESSMENT_INVITE_SENT = "assessment-invite-sent",
  ORG_INVITE_SENT = "org-invite-sent",
  TEAM_INVITE_SENT = "team-invite-sent",
  ADD_PEOPLE = "add-people",
  SEND_CANDIDATE_GPT_PROMPT = "send-candidate-gpt-prompt",
  SEND_GPT_PROMPT = "send-gpt-prompt",
  SEND_TEAM_GPT_PROMPT = "send-team-gpt-prompt",
  SEND_USER_GPT_PROMPT = "send-user-gpt-prompt",
  SEND_TEAM_MEMBER_GPT_PROMPT = "send-team-member-gpt-prompt",
  SEND_ORG_MEMBER_GPT_PROMPT = "send-org-member-gpt-prompt",
  SEND_ASSESSMENT_GPT_PROMPT = "send-assessment-gpt-prompt",
  GENERATE_GPT_SUMMARY = "generate-gpt-summary",
  GENERATE_CANDIDATE_GPT_SUMMARY = "generate-candidate-gpt-summary",
  GENERATE_TEAM_GPT_SUMMARY = "generate-team-gpt-summary",
  GENERATE_USER_GPT_SUMMARY = "generate-user-gpt-summary",
  GENERATE_TEAM_MEMBER_GPT_SUMMARY = "generate-team-member-gpt-summary",
  GENERATE_ORG_MEMBER_GPT_SUMMARY = "generate-org-member-gpt-summary",
  GENERATE_ASSESSMENT_GPT_SUMMARY = "generate-assessment-gpt-summary",
  NEW_PROJECT_CREATED = "new-project-created",
  PROJECT_SCORECARD_ROW_ADDED = "project-scorecard-row-added",
  PROJECT_SCORECARD_COMPES_MAPPED = "project-scorecard-compes-mapped",
  PROJECT_SCORECARD_TEAM_ADDED = "project-scorecard-team-added",
  PROJECT_ATTACHMENT_UPLOADED = "project-attachment-uploaded",
  CANDIDATE_ATTACHMENT_UPLOADED = "candidate-attachment-uploaded",
  NEW_TEAM_CREATED = "new-team-created",
  USER_LOGIN = "user-login",
  NEW_ACCOUNT_CREATED = "new-account-created",
  NEW_ORGANIZATION_CREATED = "create-organization",
}

export const trackAppEvent = (
  event: EVENT_NAMES,
  params: Record<string, any>
) => {
  if (window.heap) {
    window.heap.track(event, params);
  }

  if (window.Intercom) {
    window?.Intercom?.("trackEvent", event, params);
  }
};
